import type { TPlansButtonAction } from "@molecules/PlanButton/types";
import { planButtonVariant } from "@molecules/PlanButton/variables";
import { twMerge } from "tailwind-merge";

type TUpdatePlanButton = {
  target: HTMLButtonElement;
  action: TPlansButtonAction;
};

export const updatePlanButton = ({ target, action }: TUpdatePlanButton) => {
  const {
    wrapperClass,
    titleClass,
    textClass,
    wrapperBallClass,
    centerBallClass,
  } = planButtonVariant[action];

  target.className = twMerge(target.className, wrapperClass);
  target.disabled = action === "active";

  const title = target.querySelector("#title-plan-button");

  if (title) title.className = twMerge(title.className, titleClass);

  const text = target.querySelector("#text-plan-button");

  if (text) text.className = twMerge(text.className, textClass);

  const wrapperBall = target.querySelector("#wrapper-ball-plan-button");
  if (wrapperBall)
    wrapperBall.className = twMerge(wrapperBall.className, wrapperBallClass);

  const centerBall = target.querySelector("#center-ball-plan-button");
  if (centerBall)
    centerBall.className = twMerge(centerBall.className, centerBallClass);
};
